export default __webpack_public_path__ + "253e59675cc179971b389a7cb316edab.png";